import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import LoginInfo from '../login/LoginInfo';
import LogoImage from '../../../images/dried-mango-logo.svg';
import Form from 'react-bootstrap/Form';
import Button from '../../../components/shared/buttons/button';
import { toast } from 'react-toastify';
import { useForgotPasswordMutation } from "../authApi";
import { useNavigate } from "react-router-dom";
import { showToast } from '../../../helpers/Utils';
import LanguageToggleSwitch from '../../../components/shared/LanguageToggleSwitch/LanguageToggleSwitch';
import useTranslator from '../../../hooks/useTranslator';
import BackButton from "../../../components/shared/buttons/BackButton";
import { Link } from 'react-router';

const ForgetPassword = () => {
    const { _t } = useTranslator();
    const [email, setEmail] = useState('');
    const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
    const navigate = useNavigate(); // Initialize useNavigate

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            showToast(_t("enter_email_prompt", "Please enter your email address."), "error");
            return;
        }

        try {
            await forgotPassword({ email }).unwrap();
            // showToast(_t("password_reset_sent", "A password reset email has been sent to your email address."), "success");
            setEmail('');
            setTimeout(() => {
                navigate('/login');
            }, 2000);

        } catch (error) {
            console.error("Forgot Password Error:", error);
        }
    };

    return (
        <Row className='m-0'>

            <Col lg={6} className='p-0'>
                <div className='login_wrapper d-flex justify-content-center align-items-center min-vh-100'>
                    <div className='login_form'>

                        <img src={LogoImage} alt="logo" className='img-fluid' />
                        <div className="d-flex align-items-center w-full justify-content-between">
                            <h1>{_t("forget_password", "Forget Password")}</h1>
                            <LanguageToggleSwitch />
                        </div>
                        <Form onSubmit={handleSubmit}> {/* Add the form and onSubmit handler */}
                            <Form.Group className="mb-3 cmn_input">
                                <Form.Label>{_t("email", "Email")}</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder={_t("enter_your_email", "Enter your email")}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            <Button label={_t("send_email", "Send Email")} size='medium' className="w-100" type="submit" isLoading={isLoading} disabled={isLoading} /> {/* Submit button */}
                        </Form>
                       <p className='text-center mt-4 '>{_t("back_to", "Back to")} <Link to="/" className='hilight'>{_t("login", "Login")} </Link></p> 
                    </div>
                </div>
            </Col>
            <Col lg={6} className='p-0'>
                <div className='info_wrapper min-vh-100 d-flex justify-content-center align-items-center overflow-hidden position-relative'>
                    <LoginInfo />
                </div>
            </Col>
        </Row>
    );
};

export default ForgetPassword;